module.exports = __webpack_public_path__ + "static/media/uncall.b98bdf7b.png";